<template>
    <div class="Remittance">
        <div class="Cost-content">
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="汇款账号" name="second">
                    <div class="margin-top1">
                        <el-button type="primary" class="search" @click="addReset">增加</el-button>
                    </div>
                    <div class="margin-top1">
                        <el-table
                            :data="tableData"
                            :header-cell-style="headClass"
                            border
                            style="width: 100%"
                        >
                            <el-table-column prop="bank" sortable label="银行"></el-table-column>
                            <el-table-column prop="accountOpeningBranch" sortable label="开户支行"></el-table-column>
                            <el-table-column prop="accountName" sortable label="户名"></el-table-column>
                            <el-table-column prop="accountNumber" sortable label="账号"></el-table-column>
                            <el-table-column label="编辑" width="200">
                                <template slot-scope="scope">
                                    <el-button type="primary" @click="edit(scope.row)">编辑</el-button>
                                    <el-button type="danger" @click="del(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page">
                        <el-pagination
                            style="margin-right:200px;"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[50, 100, 200, 400]"
                            :page-size="pagesize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                        ></el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <el-dialog title="增加汇款账号" :visible.sync="Reimbursement" width="25%">
            <el-form :model="form">
                <el-form-item label="银行" :label-width="formLabelWidth">
                    <el-input v-model="form.bank" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="开户支行" :label-width="formLabelWidth">
                    <el-input v-model="form.accountOpeningBranch" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="户名" :label-width="formLabelWidth">
                    <el-input v-model="form.accountName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="账号" :label-width="formLabelWidth">
                    <el-input v-model="form.accountNumber" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="Reimbursement = false">取消</el-button>
                <el-button type="primary" @click="AddbankCard">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑汇款账号" :visible.sync="EditReimbursement" width="25%">
            <el-form :model="form">
                <el-form-item label="银行" :label-width="formLabelWidth">
                    <el-input v-model="form.bank1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="开户支行" :label-width="formLabelWidth">
                    <el-input v-model="form.accountOpeningBranch1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="户名" :label-width="formLabelWidth">
                    <el-input v-model="form.accountName1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="账号" :label-width="formLabelWidth">
                    <el-input v-model="form.accountNumber1" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="EditReimbursement = false">取消</el-button>
                <el-button type="primary" @click="EditbankCard">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
    name: "Remittance",
    data() {
        return {
            headClass: this.common.headClass,
            Reimbursement: false,
            EditReimbursement: false,
            formLabelWidth: "90px",
            input: "",
            activeName: "second",
            form: {
                bank: "",
                accountOpeningBranch: "",
                accountName: "",
                accountNumber: "",

                bank1: "",
                accountOpeningBranch1: "",
                accountName1: "",
                accountNumber1: "",

                id: ""
            },
            currentPage: 1,
            pagesize: 50,
            size: 50,
            total: 0,
            tableData: []
        };
    },
    mounted() {},
    created() {
        this.role = JSON.parse(window.localStorage.getItem("role"));
        this.dataList();
    },
    methods: {
        dataList() {
            var obj = {
                companyId: this.role.company_id,
                page: this.currentPage,
                size: this.size
            };
            ajaxPost(
                Baseurl +
                    "remittanceAccountController/selectRemittanceAccountInfoByCompanyId",
                obj
            ).then(res => {
                this.tableData = res.data.data.list;
                this.total = res.data.data.total;
            });
        },
        AddbankCard() {
            var obj = {
                companyId: this.role.company_id,
                bank: this.form.bank,
                accountOpeningBranch: this.form.accountOpeningBranch,
                accountName: this.form.accountName,
                accountNumber: this.form.accountNumber
            };
            ajaxPost(
                Baseurl +
                    "remittanceAccountController/insertRemittanceAccountInfo",
                obj
            ).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "增加汇款账号成功"
                    });
                    this.dataList();
                } else {
                    this.$message.error("增加汇款账号失败");
                }
                (this.form.bank = ""),
                    (this.form.accountOpeningBranch = ""),
                    (this.form.accountName = "");
                this.form.accountNumber = "";
                this.Reimbursement = false;
            });
        },
        edit(item) {
            this.EditReimbursement = true;
            console.log(item);
            this.form.accountName1 = item.accountName;
            this.form.accountNumber1 = item.accountNumber;
            this.form.accountOpeningBranch1 = item.accountOpeningBranch;
            this.form.bank1 = item.bank;
            this.form.id = item.id;
        },
        EditbankCard() {
            var obj = {
                companyId: this.role.company_id,
                bank: this.form.bank1,
                accountOpeningBranch: this.form.accountOpeningBranch1,
                accountName: this.form.accountName1,
                accountNumber: this.form.accountNumber1,
                id: this.form.id
            };
            ajaxPost(
                Baseurl +
                    "remittanceAccountController/updateRemittanceAccountInfo",
                obj
            ).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "编辑汇款账号成功"
                    });
                    this.dataList();
                } else {
                    this.$message.error("编辑汇款账号失败");
                }
            });
            this.EditReimbursement = false;
        },
        del(val) {
            this.$confirm("删除当前汇款账号, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    var obj = {
                        id: val.id
                    };
                    ajaxPost(
                        Baseurl +
                            "remittanceAccountController/deleteRemittanceAccountInfoById",
                        obj
                    ).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                type: "success",
                                message: "删除汇款账号成功!"
                            });
                            this.dataList();
                        } else {
                            this.$message.error("删除汇款账号失败");
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.size = val;
            var company_id = {
                companyId: this.role.company_id,
                page: this.currentPage,
                size: this.size
            };
            ajaxPost(
                Baseurl +
                    "remittanceAccountController/selectRemittanceAccountInfoByCompanyId",
                company_id
            ).then(res => {
                this.tableData = res.data.data.list;
                this.total = res.data.data.total;
            });
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
            var company_id = {
                companyId: this.role.company_id,
                page: this.currentPage,
                size: this.size
            };
            ajaxPost(
                Baseurl +
                    "remittanceAccountController/selectRemittanceAccountInfoByCompanyId",
                company_id
            ).then(res => {
                this.tableData = res.data.data.list;
                this.total = res.data.data.total;
            });
        },
        handleRemove(file) {
            console.log(file);
        },
        addReset() {
            this.Reimbursement = true;
        }
    }
};
</script>

<style lang="scss">
.Remittance {
    width: 98%;
    overflow: hidden;
    .el-form-item__label {
        text-align: left;
    }
    .Cost-content {
        margin-top: 20px;
        .el-form-item {
            overflow: hidden;
            width: 18%;
            margin-bottom: 18px;
            float: left;
        }
        .remittance_account {
            position: absolute;
            right: 10%;
            top: 6%;
        }
        .Reportform_tiem {
            overflow: hidden;
            border-top: 1px solid #eee;
            padding: 15px 0;
            .search-result-text {
                font-size: 14px;
                color: #606266;
                padding: 0;
            }
            .el-radio-group {
                display: inline-block;
                line-height: 1;
                vertical-align: middle;
                font-size: 0;
                margin-left: 20px;
            }
        }
        .paging {
            width: 40%;
            margin: 20px auto;
        }
    }
    .el-dialog__wrapper {
        .el-dialog__body {
            .dialog-item {
                margin-bottom: 20px;
                .dialog-left {
                    margin-right: 50px;
                }
            }
        }
        .remittance {
            width: 96%;
            margin: 30px auto 0;
            padding: 0 0 30px 0;
            overflow: hidden;
        }
    }
    .page {
        position: fixed;
        width: 100%;
        bottom: 0;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
    }
}
</style>
